import React, { useState, useEffect } from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Table, Tag, Space, Tabs, Badge, Form, Select, Input } from 'antd';
import { Config } from '../../config/config';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import moment from "moment";
import {Button, DatePicker} from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { useNavigate, useLocation } from 'react-router';
import { doGetWorkOrderInfo, doAcceptWorkRequest , doRejectWorkRequest, loadTicketHistory, PostSelectedData, loadallWorkRequestInforeact, loadallWorkRequestInfofilterreact, clearWorkOrderDetails } from './actions/workOrderService';
import { DownloadWorkRequestReports, ClearData } from '../PMP/actions/pmpService';
import { GetTechnicianPMPList } from '../PMP/actions/pmpService';
import { useDispatch,useSelector } from 'react-redux';
import Cookie from 'js-cookie';
import ViewQuotation from '../Quotation/ViewQuotation';
import AddQuotation from '../Quotation/AddQuotation';
import LZString from 'lz-string';
import dayjs from 'dayjs';

const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;

const WorkOrderVendor = () =>{
  const config = JSON.parse(Config);
  const title= 'Work Order Vendor';
  const apiInterface= config['api1'];

  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData) 
  let userID = user['userId']
  const PendingFromVendorTableColumns = [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size="middle">
            <div className="table-icons">
              <i className="fa fa-eye orange" aria-hidden="true" onClick={_doNavToAddStore}></i>
            </div>
          </Space>
        )
      }

    },
    {
      title: "Request ID",
      dataIndex: "work_request_id",
      key: "Request ID"

    },
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "Store Name"
    },
    {
      title: "Asset Name",
      dataIndex: "asset_name",
      key: "asset_name"

    },
    {
      title: "Scheduled Date & Time",
      dataIndex: "created_on",
      key: "created_on"
    },
    {
      title: "Status",
      dataIndex: "work_request_status_desc",
      key: "work_request_status_desc"
    }
  ]
  const WorkRequestedTableColumns= [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size="middle">
            <div className="table-icons">
              <i className={(record.Status === "Rejected" ? 'fa fa-eye orange' : 'fa fa-pencil blue')} aria-hidden="true" onClick={_doNavToAddStore}></i>
            </div>
          </Space>
        )
      }

    },
    {
      title: "RequestID",
      dataIndex: "RequestID",
      key: "RequestID"
    },
    {
      title: "Scheduled Date & Time",
      dataIndex: "ScheduledDateTime",
      key: "ScheduledDateTime"
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status"
    }
  ];
  const WorkRequestedTableData= [
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      Status: 'Pending for confirmation',
      key: '1'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      Status: 'Pending for confirmation',
      key: '2'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      Status: 'Pending for confirmation',
      key: '3'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      Status: 'Rejected',
      key: '4'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      Status: 'Rejected',
      key: '5'
    }
  ];
  const WorkInProgressTableColumns= [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size="middle">
            <div className="table-icons">
              <i className={(record.Status === "Technician InComplete" ? 'fa fa-pencil blue' : 'fa fa-eye orange')} aria-hidden="true" onClick={_doNavToAddStore}></i>
            </div>
          </Space>
        )
      }

    },
    {
      title: "RequestID",
      dataIndex: "RequestID",
      key: "RequestID"
    },
    {
      title: "Scheduled Date & Time",
      dataIndex: "ScheduledDateTime",
      key: "ScheduledDateTime"
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status"
    }
  ];
  const WorkInProgressTableData= [
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      Status: 'Assigned to Technician',
      key: '1'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      Status: 'Under Quotation',
      key: '2'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      Status: 'Technician Completed',
      key: '3'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      Status: 'Technician InComplete',
      key: '4'
    }
  ];
  const WorkClosedTableColumns= [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size="middle">
            <div className="table-icons">
              <i className="fa fa-eye orange" aria-hidden="true" onClick={_doNavToAddStore}></i>
            </div>
          </Space>
        )
      }

    },
    {
      title: "RequestID",
      dataIndex: "RequestID",
      key: "RequestID"
    },
    {
      title: "Scheduled Date & Time",
      dataIndex: "ScheduledDateTime",
      key: "ScheduledDateTime"
    },
    {
      title: "Completed Date & Time",
      dataIndex: "CompletedDateTime",
      key: "CompletedDateTime"
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status"
    }
  ];
  const WorkClosedTableData= [
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      CompletedDateTime: '17-09-2021 9:00PM',
      Status: 'Closed',
      key: '1'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      CompletedDateTime: '17-09-2021 9:00PM',
      Status: 'Closed',
      key: '2'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      CompletedDateTime: '17-09-2021 9:00PM',
      Status: 'Closed',
      key: '3'
    },
    {
      RequestID: '123',
      ScheduledDateTime: '16-09-2021 3:00PM',
      CompletedDateTime: '17-09-2021 9:00PM',
      Status: 'Closed',
      key: '4'
    }
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation()
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [modalOpen, setModalOpen] = useState(false)
  const WorkOrderStore = useSelector(state => state.WorkOrderStore)
  const WorkOrderStoreDetails = useSelector(state => state?.WorkOrderStore?.WorkRequestInfo?.WorkOrderStoreDetails)
  const WorkOrderStoreData = useSelector(state => state?.WorkOrderStore?.WorkRequestInfo?.WorkOrderStoreData)
  const TechnicianList = useSelector(state => state?.pmpList?.TechnicianDetails?.TechnicianList)
  const TicketHistory = useSelector(state => state?.WorkOrderStore?.TicketHistory)
  const StoreDetails = useSelector(state => state?.WorkOrderStore?.WorkRequestInfo?.StoreDetails)
  const WorkRequestReportData = useSelector(state=> state?.pmpList?.WorkRequestReportData?.WorkRequestReportData)
  const SubCategoryList = useSelector(state=> state?.pmpList?.WorkRequestReportData?.SubCategoryList)
  const [reportTableData, setReportTableData] = useState([])
  const [reportSubId,setReportSubId] = useState(null);
  const [TabDetails, setTabDetails] = useState([])
  const [storeId, setStoreId] = useState([]);
  const [RescheduledByStore, setRescheduledByStore] = useState(false);
  const [PendingForConfirmationByVendorAccept, setPendingForConfirmationByVendorAccept] = useState(false);
  const [PendingForConfirmationByVendorReject, setPendingForConfirmationByVendorReject] = useState(false);
  const [WorkRejected, setWorkRejected] = useState(false);
  const [AssignedToTech, setAssignedToTech] = useState(false);
  const [TechCompleted, setTechCompleted] = useState(false);
  const [TechInComplete, setTechInComplete] = useState(false);
  const [UnderQuotation, setUnderQuotation] = useState(false);
  const [WorkClosed, setWorkClosed] = useState(false);
  const [WorkHistory, setWorkHistory] = useState(false);
  const [PendingFromVendorTableData, setPendingFromVendorTableData] = useState([]);
  const [isPendingFromVendor, setIsPendingFromVendor] = useState(false);
  const [selectedData,setSelectedData] = useState([]);
  const [resForRej, setResForRej] = useState('');
  const [remarks, setRemarks] = useState('');
  const [isWorkRejectedByStore, setIsWorkRejectedByStore] = useState(false);
  const [key, setKey] = useState('1');
  const [RejectedByVendor, setRejectedByVendor] = useState(false);
  const [isViewAddQuotation, setIsViewAddQuotation] = useState(false);
  const [acceptWorkRequest, setAcceptWorkRequest] = useState({
    fedid :userID,
    workrequestid:'',
    workrequest_type:0,
    work_request_comments :'',
    technician:'',
    technician_number :'',
    reason_for_reject :'',

  });
  const [rejectWorkRequest, setRejectWorkRequest] = useState({
    fedid : userID,
    workrequestid :'',
    workrequest_type :0,
    work_request_comments:'',
    technician:'',
    technician_number:'',
    reason_for_reject:'',
  });
  const [isVendorView, setIsVendorView] = useState(true);
  const [isViewQutation, setIsViewQutation] = useState(false);
  const vendorDropdownDetails = useSelector(state=> state?.WorkOrderStore?.WorkRequestInfo1?.VendorDropdownDetails)
  const isCache = useSelector(state=> state?.WorkOrderStore?.isCache);
    const [filteredVendorDropdownDetails, setFilteredVendorDropdownDetails] = useState([])
    const [vendorId, setVendorId] = useState([]);
    const [priorityId, setPriorityId] = useState([]);
    const[selectedStartDate, setSelectedStartDate] = useState("")
    const[selectedEndDate, setSelectedEndDate] = useState("")
    const [isSearched, setIsSearched] = useState(false);
    const [filteredStoreDetails, setFilteredStoreDetails] = useState([])
    const [cityIds, setCityIds] = useState([]);
    const CityDropdownDetails = useSelector(state => state?.WorkOrderStore?.WorkRequestInfo?.CityDropdownDetails)
  const openViewQuotation = () => {
    setIsVendorView(false);
    setIsViewQutation(true);
  } 
  const handleCityIds = (values) => {
    setCityIds(values);
    let filterArray = values.flatMap(value=>StoreDetails.filter(ele=> ele.store_city ==value));
    let storeIds;
    setFilteredStoreDetails(filterArray);
    storeIds = filterArray.flatMap(ele=> storeId.filter(ele1=>ele1 == ele.store_id));
    setStoreId(storeIds);
  }
  const handleSearch1 = () =>{
    setIsSearched(true);
    if(selectedStartDate =="" ||selectedEndDate=="" ){
      // alert("Please select startDate and EndDate");
      return;
    }
    //caching start date and end for future use while coming from create quotation
    // localStorage.setItem("vendor_start_date", selectedStartDate);
    // localStorage.setItem("vendor_end_date", selectedEndDate);
    setIsSearched(false);
    const uniqueVendorDetails = Object.values(vendorDropdownDetails.reduce((acc, obj) => {
      const key = obj.vendor_id;
      if (!acc[key])
        acc[key] = {...obj };
      return acc;
    }, {}));
    let vendorids = vendorId.map(ele=> Number(ele));
    let allOrVendorIds = vendorId=="" || vendorId.length==0 ? filteredVendorDropdownDetails.length>0 ?filteredVendorDropdownDetails.map(ele=> Number(ele.vendor_id)): uniqueVendorDetails.map(ele=> Number(ele.vendor_id)):vendorId.map(ele=> Number(ele))
    let allOrStoreIds = storeId=="" || storeId.length==0 ?filteredStoreDetails.length>0 ? filteredStoreDetails.map(ele=> ele.store_id):StoreDetails.map(ele=> ele.store_id):storeId
    let allOrPriority = priorityId=="" || priorityId.length==0 ? ["High","Medium","Low"]:priorityId
    let payload = {
      "storeidlist": allOrStoreIds,
      "vendoridlist" : allOrVendorIds,
      "priorityList" : allOrPriority,
      "startdate" : dayjs(selectedStartDate).format("YYYY-MM-DD"),
      "enddate" :  dayjs(selectedEndDate).format("YYYY-MM-DD")
    }
    dispatch(loadallWorkRequestInfofilterreact(payload));
  }
  const StoresList= [
    {
      Label: "Connect Store - ITPB",
      Value: 1
    },
    {
      Label: "Connect Store- Indiranagar",
      Value: 2
    },
    {
      Label: "Sarjapur",
      Value: 3
    },
    {
      Label: "Anubhava (New Airport Road)",
      Value: 4
    },
    {
      Label: "EVA Mall - Brigade",
      Value: 5
    },
    {
      Label: "R-city(Mumbai)",
      Value: 6
    },
    {
      Label: "Amanora Mall",
      Value: 7
    },
    {
      Label: "OMR Padur(Chennai)",
      Value: 8
    },
    {
      Label: "Teynampet / Ramee Mall / Anna Salai",
      Value: 9
    },
    {
      Label: "Kukatpally (Manjeera Mall)",
      Value: 10
    },
    {
      Label: "Vishakapatnam (Murli Nagar)",
      Value: 11
    },
  ]
  
  const _doNavToAddStore = () =>{}
  const _doGetWorkOrderVendorList = () => {
    setLoading(true)
    setModalOpen(false)
    setMessage('')
  };
  const _doSelectVender = () =>{}
  const  _doNavToQuotation = (pageUrl) => {
    if (pageUrl === 'Add') {
      // navigate("/AddQuotation");
    //   navigate({
    //     pathname: '/AddQuotation',
    //     state: { fromAddress:'/WorkOrderVendor', selectedId:storeId }
    // });
    openAddQuotation()
    } else {
    // navigate("/ViewQuotation");
  //   navigate({
  //     pathname: '/ViewQuotation',
  //     state: { fromAddress:'/WorkOrderVendor', selectedId:storeId }
  // });
  openViewQuotation();
    }
  };
  const openAddQuotation = () => {
    setIsVendorView(false);
    setIsViewAddQuotation(true);
    setIsViewQutation(false);
}
  // Open modal based on table row selection
  const _doGetRowData = (item) => {
    console.log(item, 'Clicked row item');
    _doCloseModal('CloseAll')
    setSelectedData(item)
    if (item.work_request_status_desc === 'Rescheduled by Store') {
      setRescheduledByStore(true)
    }
    else if (item.work_request_status_desc === 'Rejected') {
      setWorkRejected(true)
    }
    else if (item.work_request_status_desc === 'Accepted by Vendor') {
      setAssignedToTech(true)
    }
    else if (item.work_request_status_desc === 'Technician Completed') {
      setTechCompleted(true)
    }
    else if (item.work_request_status_desc === 'Technician Incomplete') {
      dispatch((PostSelectedData(item)))
      setTechInComplete(true)
    }
    else if (item.work_request_status_desc === 'Under Quotation') {
      setUnderQuotation(true)
    }
    else if (item.work_request_status_desc === 'Closed') {
      dispatch((PostSelectedData(item)))
      setWorkClosed(true)
    }
    else if (item.work_request_status_desc === 'Pending from Vendor') {
      // setIsPendingFromVendor(true);
      setRescheduledByStore(true)
    }
    else if (item.work_request_status_desc === 'Rejected By Vendor') {
      setRejectedByVendor(true)
    }
    else if (item.work_request_status_desc === 'Work Rejected by Store') {
      setIsWorkRejectedByStore(true)
    }
  }

  const _doCloseModal = (state) => {
    if (state == "pendingForConfirmation") {
      _doClosePendingConfirmModal();
    }
    else if (state == "Rejected") {
      setWorkRejected(false)
      setWorkHistory(false)
    }
    else if (state == "AssignedToTech") {
      setAssignedToTech(false)
      setWorkHistory(false)
    }
    else if (state == "TechCompleted") {
      setTechCompleted(false)
      setWorkHistory(false)
    }
    else if (state == "TechInComplete") {
      setTechInComplete(false);
      setWorkHistory(false)
    }
    else if (state == "UnderQuotation") {
      setUnderQuotation(false)
      setWorkHistory(false)
    }
    else if (state == "WorkClosed") {
      setWorkClosed(false)
      setWorkHistory(false)
    }
    else if (state == "pendingFromVendor") {
      setWorkHistory(false)
      setIsPendingFromVendor(false);
    }
    else if (state == "RejectedByVendor") {
      setWorkHistory(false)
      setRejectedByVendor(false);
    }
    else if (state == "WorkRejectedByStore") {
      setWorkHistory(false)
      setIsWorkRejectedByStore(false);
    }
    else if(state === "CloseAll"){
      _doClosePendingConfirmModal()
      setWorkRejected(false)
      setAssignedToTech(false)
      setTechCompleted(false)
      setTechInComplete(false)
      setUnderQuotation(false)
      setWorkClosed(false)
      setIsPendingFromVendor(false)
      setRejectedByVendor(false)
      setIsWorkRejectedByStore(false)
      setWorkHistory(false)
    }
  };

  const _doVendorReject = (e) => {
    console.log('Helloo', e);
    e.stopPropagation();
    setPendingForConfirmationByVendorAccept(false)
    setPendingForConfirmationByVendorReject(true)
    // this._doClosePendingConfirmModal();
    // ! Call REJECTED API here
  }
  const [formAccept] = Form.useForm();
  const [formAccept1] = Form.useForm();
  const [formReject] = Form.useForm();
  const _doVendorRejected = ()=>{
    _doClosePendingConfirmModal();
    rejectWorkRequest.workrequestid = Number(selectedData?.work_request_id)
    rejectWorkRequest.technician = selectedData?.technician
    rejectWorkRequest.technician_number = selectedData?.technician_number
    rejectWorkRequest.work_request_comments = rejectWorkRequest.reason_for_reject +"-"+rejectWorkRequest.work_request_comments
    console.log(rejectWorkRequest,'rejectWorkRequest')
    dispatch(doRejectWorkRequest(rejectWorkRequest))
  }
  const _doVendorAccept = () => {
    setPendingForConfirmationByVendorReject(false)
    setPendingForConfirmationByVendorAccept(true)
  }

  const _doPrevAction = (element) => {
    if (element === 'AcceptBackBtn') {
      setPendingForConfirmationByVendorAccept(false)
    } else if (element === 'RejectBackBtn') {
      setPendingForConfirmationByVendorReject(false)
      setWorkHistory(false)
    }
  }
  const _doVendorAccepted = () => {
   _doClosePendingConfirmModal();
   acceptWorkRequest.workrequestid = Number(selectedData?.work_request_id)
   console.log(acceptWorkRequest,'acceptWorkRequest')
   dispatch(doAcceptWorkRequest(acceptWorkRequest))
    // ! Call ACCEPTED API here
  }

  const _doClosePendingConfirmModal = () => {
    setRescheduledByStore(false)
    setPendingForConfirmationByVendorAccept(false)
    setPendingForConfirmationByVendorReject(false)
    setWorkHistory(false)
  }

  const _doToogleRemarks = (curentState) => {
    if (curentState === 'show') {
      setWorkHistory(true)
    } else {
      setWorkHistory(false)
    }
  }
  const downloadReport = ()=>{
    console.log(selectedData,'record')
    // window.location.href = apiInterface+`/downloadimages?Image_id=${selectedData?.pdf_path}`
    window.location.href = `${apiInterface}/downloadfiles?Image_id=${selectedData?.pdf_path}&token_id=${Cookie.get('token')}`
  }
  // useEffect(()=>{
  //   debugger;
  //   let vendor_start_date = localStorage.getItem("vendor_start_date");
  //   let vendor_end_date = localStorage.getItem("vendor_end_date");
  //   if(vendor_start_date){
  //     setSelectedStartDate(moment(vendor_start_date));
  //   }
  //   if(vendor_end_date){
  //     setSelectedEndDate(moment(vendor_end_date));
  //   }
  //   if(vendor_start_date && vendor_end_date){
  //   if(isCache){
  //     // handleSearch1();
  //   }
  //   }
  // },[isCache]) 
  useEffect(()=>{
    if(!WorkOrderStoreDetails){
      return;
    }
    const uniqueStatuses = Object.values(WorkOrderStoreDetails?.reduce((acc, obj) => {
      const key = obj.work_request_status_desc;
      if (acc[key]) {
        acc[key].count += obj.count;
      } else {
        acc[key] = {...obj };
      }
      return acc;
    }, {}));
    setTabDetails(uniqueStatuses);
    handleData1(uniqueStatuses.length>0?uniqueStatuses[0]:[],uniqueStatuses)
    console.log(WorkOrderStoreDetails,'WorkOrderStoreDetails')
  },[WorkOrderStoreDetails])
  const handleData1 = (tab, tabDetails=[]) => {
    setKey(tab?.work_request_status_desc)
    const  filteredPendingVendorTableData = WorkOrderStoreData?.filter(item=> item.search_filter ==tab.search_filter)
    setPendingFromVendorTableData(filteredPendingVendorTableData);
    // handleTabsCount(tabDetails);
  }
  
  const handleData = (data)=>{
    if(data){
      setKey(data?.work_request_status_desc)
      const  PendingFromVendorTableData = WorkOrderStoreData?.filter(item=> item.store_id == data.store_id && item.search_filter ==data.search_filter)
      // console.log(PendingFromVendorTableData,'pendingfromvendortabledata')
      setPendingFromVendorTableData(PendingFromVendorTableData);
    }
    else{
      setPendingFromVendorTableData([])
    }
  }
  const StausbasedData = (status) =>{
    const data =WorkOrderStoreDetails?.filter(item=> item.work_request_status_desc === status)
    return data;
  }
  const loadTicket = (id) =>{
    dispatch(loadTicketHistory(id))
  }
  // const handleStoreId = (value) =>{
  //   console.log(value,'value')
  //   setStoreId(value)
  // }
  const handleStoreId = (value) =>{
    let filteredVendorData = value.flatMap(item=> vendorDropdownDetails.filter(vendor=> vendor.store_id == item));
    console.log(filteredVendorData, 'filteredVendorData')
    let uniqueStatuses = Object.values(filteredVendorData.reduce((acc, obj) => {
      const key = obj.vendor_id;
      if (!acc[key])
        acc[key] = {...obj };
      return acc;
    }, {}));
    //filter by vendor company name if vendor is loggedIn
    if(user.roles.includes("Vendor")){
      uniqueStatuses = uniqueStatuses.filter(item => {
        return item.vendor_company_name === user.givenName
      })
    }
    setFilteredVendorDropdownDetails(uniqueStatuses);
    setStoreId(value)
    
  }
  const handleSearch = (value) =>{
    // console.log(value,'data')
    let data = WorkOrderStoreDetails?.filter(ele=>ele.store_id == value)
    // console.log(data,'data')
    setTabDetails(data)
    handleData(data.length>0 ? data[0]:[])
  }
  useEffect(() => {
    _doGetWorkOrderVendorList()
    dispatch(doGetWorkOrderInfo())
    dispatch(GetTechnicianPMPList())
    dispatch(loadallWorkRequestInforeact())
    return()=>{
      dispatch(ClearData())
      dispatch(clearWorkOrderDetails());
    }
  }, [])
  useEffect(()=>{
    setReportTableData(WorkRequestReportData)
  },[WorkRequestReportData])
  // useEffect(() => {
  //   if((WorkOrderStoreDetails)!=undefined){
  //     if(WorkOrderStoreDetails.length!=0){
  //       // const data = StausbasedData(WorkOrderStoreDetails[0].work_request_status_desc);
  //       // const  PendingFromVendor = WorkOrderStoreData?.filter(item=>item.store_id == data[0]?.store_id && item.search_filter === data[0]?.search_filter)
  //       // setPendingFromVendorTableData(PendingFromVendor)
  //       // console.log(PendingFromVendor,'workInprogr')
  //   }
  //   if(typeof(StoreDetails) != 'undefined'){
  //     // var allFilteredData= WorkOrderStoreDetails?.filter(ele=> ele.store_id == StoreDetails[0]?.store_id)
  //     // setTabDetails(allFilteredData)
  //     // if(typeof(location.state)=='undefined'){
  //     //   console.log(location.state,'location.state')
  //     //   setStoreId(StoreDetails[0]?.store_id)
  //     //   handleSearch(StoreDetails[0]?.store_id)
  //     // }
  //     // else{
  //     //   console.log(location.state,'location.state')
  //     //   setStoreId(location.state.selectedStoreId)
  //     //   handleSearch(location.state.selectedStoreId)
  //     // }
  //   }}
  // }, [WorkOrderStoreDetails, StoreDetails, location])

  const [reportData,setReportData] =useState({
    startDate:null,
    endDate:null,
    storeId:null
  })
  const [isSubmit,setIsSubmit] = useState(false)
  const [isReportGenerator, setIsReportGenerator] = useState(false)
  const [isModalVisible,setIsModalVisible] = useState(false)
  const handleSearchReport = ()=>{
    setIsSubmit(true)
    if(reportData.storeId==null) return
    else if(reportData.startDate == null|| reportData.startDate =='') return
    else if(reportData.endDate == null || reportData.endDate == '') return
    console.log(reportData,'reportData')
    const jsonData = {
      start_date:reportData.startDate,
      end_date:reportData.endDate,
      store_id:reportData.storeId,
    }
    dispatch(DownloadWorkRequestReports(jsonData))
  }
  const handleReportGenerator = () => {
    setIsReportGenerator(true)
    setIsModalVisible(true)
  }
  const handleCloseReportGenerator = () => {
  setIsSubmit(false)
  setReportData({...reportData,storeId:null,startDate:null,endDate:null})
  setReportSubId(null)
  dispatch(ClearData())
  setIsModalVisible(false);
  setIsReportGenerator(false);
  };
  const handleDownloadReport = (data) => {
  // window.location.href = `${apiInterface}/downloadimages?Image_id=${data.pdf_path}`
    if(data.pdf_path!=""  && data.pdf_path.includes('.pdf')==true){
      // window.location.href = `${apiInterface}/downloadimages?Image_id=${data.pdf_path}`
      window.location.href = `${apiInterface}/downloadfiles?Image_id=${data.pdf_path}&token_id=${Cookie.get('token')}`
    }
  }
  const  disabledDate = (current) => {
    // let date = moment().add(1,'days')
    // return current && current > moment(date,'DD-MM-YYYY').startOf('day');
    let date = dayjs().add(1, 'day').startOf('day');
    return current && current > date;
  }
  const handleReportTableData = () =>{
    if(reportSubId==null || typeof(reportSubId) =="undefined"){
      setReportTableData(WorkRequestReportData)
    }
    else{
      let data = [];
      let fetchedData = WorkRequestReportData?.filter(ele=>ele.sub_category_id == reportSubId).map(e=>data.push(e))
      setReportTableData(data)
    }
  }
  const CloseQuotation = () =>{
    debugger;
    _doCloseModal("CloseAll")
    setIsVendorView(true);
    setIsViewQutation(false);
    setIsViewAddQuotation(false);
  }
  const CloseAddViewQuotation = () =>{
    _doCloseModal("CloseAll")
    setIsVendorView(true);
    setIsViewQutation(false);
    setIsViewAddQuotation(false);
    handleSearch1();
  }
  const handleVendorSelection = (value) => {
    setVendorId(value);
  }
  const handlePrioritySelection = (value) => {
    setPriorityId(value);
  }
    return (
      <>
      {isVendorView === true ?
        <div>
          {WorkOrderStore?.modalOpen ? (
            <MessageBox
              message={WorkOrderStore?.message}
              // signout={false}
              onClose={()=>{
                dispatch(doGetWorkOrderInfo())
                  dispatch(GetTechnicianPMPList())
              }}
            />
          ) : null}

          <div className="wrapper">
            <Header title={title} />
            <Menu />
            <div className='content-wrapper'>
              {WorkOrderStore?.loading ? (
                <Spinner />
              ) : (
                <div>
                  <section className='content'>
                    <div className="m-panel mt-10">
                      <div className="m-panel__body p10">
                        <div className="row">
                          <div className="col-md-3">
                              <div className='form-group select_h150'>
                                <label htmlFor='exampleInput'>Select City</label>
                                <Select className="form-control"
                                mode="multiple"
                                  showSearch
                                  name="exampleInput"
                                  onChange={(value)=>handleCityIds(value)}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  value={cityIds}
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                  CityDropdownDetails?.map((item =>
                                      <Option key={item.store_city} value={item.store_city}>{item.city_name}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                          <div className="col-md-3">
                              <div className='form-group select_h150'>
                                <label htmlFor='exampleInput'>Select Store</label>
                                <Select className="form-control"
                                mode="multiple"
                                  showSearch
                                  name="exampleInput"
                                  onChange={(value)=>handleStoreId(value)}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  value={storeId}
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                  filteredStoreDetails?.map((item =>
                                      <Option key={item.store_id} value={item.store_id}>{item.store_name}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>

                            <div className="col-md-3">
                                <div className='form-group select_h150'>
                                  <label htmlFor='exampleInput'>Select Vendor</label>
                                  <Select className="form-control"
                                  mode="multiple"
                                    showSearch
                                    name="exampleInput"
                                    onChange={(value)=>handleVendorSelection(value)}
                                    placeholder="-- Please Select --"
                                    optionFilterProp="children"
                                    value={vendorId}
                                    filterOption={(input, option) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  > 
                                  {/* <Option  value="All">All</Option> */}
                                  {
                                    filteredVendorDropdownDetails?.map(((item,index) =>
                                        <Option key={index} value={item.vendor_id}>{item.vendor_company_name}</Option>
                                      ))
                                    }
                                  </Select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className='form-group select_h150'>
                                  <label htmlFor='exampleInput'>Select Priority</label>
                                  <Select className="form-control"
                                  mode="multiple"
                                    showSearch
                                    name="exampleInput"
                                    onChange={(value)=>handlePrioritySelection(value)}
                                    placeholder="-- Please Select --"
                                    optionFilterProp="children"
                                    value={priorityId}
                                    filterOption={(input, option) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  > 
                                    {/* <Option  value="All">All</Option> */}
                                    <Option value ="High">High</Option>
                                    <Option value ="Medium">Medium</Option>
                                    <Option value ="Low">Low</Option>
                                  </Select>
                                </div>
                            </div>

                          {/* <div className="col-md-1 btn-no-lbl">
                            <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={()=>handleSearch(storeId)}>
                              <i className="fa fa-search"></i>
                            </button>
                          </div>

                          <div className="col-md-1 btn-no-lbl">
                              <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleReportGenerator}>
                                View Report
                              </button>
                            </div> */}

                        </div>
                        <div className='row'>
                          <div className="col-md-3">
                                <div className='form-group select_h150'>
                                  <label htmlFor='exampleInput'>Select Start Date</label>
                                  <DatePicker  
                                  value={selectedStartDate}
                                  onChange={(date)=> setSelectedStartDate(date)} 
                                                placeholder="Select Date & Time" format="YYYY-MM-DD" className="form-control"
                                            />
                                  {isSearched== true && selectedStartDate =="" && <p className='text-danger'>Please select Start Date</p>}
                                </div>
                          </div>
                          <div className="col-md-3">
                              <div className='form-group select_h150'>
                                <label htmlFor='exampleInput'>Select End Date</label>
                                <DatePicker  
                                value={selectedEndDate}
                                onChange={(date)=>setSelectedEndDate(date)}
                                              placeholder="Select Date & Time" format="YYYY-MM-DD" className="form-control"
                                          />
                                          {isSearched== true && selectedEndDate =="" && <p className='text-danger'>Please select End Date</p>}
                              </div>
                          </div>
                          <div className="col-md-1 btn-no-lbl">
                            {/* <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={()=>handleSearch(storeId)}>
                              <i className="fa fa-search"></i>
                            </button> */}
                            <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={()=>handleSearch1()}>
                              <i className="fa fa-search"></i>
                            </button>
                          </div>

                          <div className="col-md-1 btn-no-lbl">
                              <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleReportGenerator}>
                                View Report
                              </button>
                            </div>

                        </div>
                      </div>
                    </div>
                    <div className="m-panel mt-10">
                      <div className="m-panel__body p10 custom-tabs">
                        <Tabs defaultActiveKey="1" activeKey={key}>
                            {TabDetails?.map((item,index)=>{
                              return(
                                <TabPane
                                  tab={
                                    <p key={index} style={{color:item.work_request_status_colour}} onClick={()=>handleData1(item)}>
                                      <span style={{color:'black'}}>{item.count}</span> {item.work_request_status_desc}
                                    </p> 
                                  }
                                  key={item.work_request_status_desc}
                                >
                                  <div className="m-table__main">
                                    <div className="m-table__responsive medium-width">
                                      <Table
                                        filterSearch="true"
                                        onRow={(record, recordIndex) => ({
                                          onClick: event => { { _doGetRowData(record, recordIndex) } }
                                        })}
                                        columns={PendingFromVendorTableColumns}
                                        dataSource={PendingFromVendorTableData}/>
                                    </div>
                                  </div>
                                </TabPane>
                              )
                            })}
                        </Tabs>
                      </div>
                    </div>
                  </section>
                </div>
              )};
            </div>
            <Footer />
            {RescheduledByStore === true ?
              <div className="m-modal">
                <div className="m-modal__container">
                  <div className="m-modal__header">
                    <h5 className="m-modal__title"> Pending For Confirmation </h5>
                    <span className="m-modal__close" onClick={() => _doCloseModal('pendingForConfirmation')}>
                      <i className="fa fa-close"></i>
                    </span>
                  </div>
                  <div className="m-modal__body">
                    <div className="row">
                    <div className="col-md-12 text-center">
                      <div className="m-page__button  top-space text-center">
                        <button type='button' className='btn muted-button  deca-btn-orange' onClick={_doVendorReject}>Reject</button>
                        <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={_doVendorAccept}>Accept</button>
                      </div>
                    </div>
                      <div className="col-md-12">
                        <div className="">
                          <div className="c-pic__img">
                          
                            {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                            {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                          </div>
                        </div>
                      </div>
                      {PendingForConfirmationByVendorAccept === false && PendingForConfirmationByVendorReject === false ?
                        <React.Fragment>
                          {WorkHistory == true ?
                            <React.Fragment>
                              <div className="col-md-12">
                                <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                              </div>
                              <div className="col-md-12">
                                <ul className="remarks__list">
                                  {TicketHistory?.map((item,index)=>{
                                    return(
                                      <li className="remarks__item">
                                        <div className="remarks__userdetails">
                                          <h5>{item.from}</h5>
                                          <h5>{item.work_request_start_date}</h5>
                                        </div>
                                        <div className="remarks__reason">
                                          <h5>Comments</h5>
                                          <p>{item.work_request_comments}</p>
                                        </div>
                                        <div className="remarks__userdetails">
                                          <p>Reschedule Date</p>
                                          <p>{item.work_request_reschedule_date}</p>
                                        </div>
                                      </li>
                                    )
                                })}
                                  
                                </ul>
                              </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                              <div className="col-md-12 status_remarks">
                              {selectedData?.pdf_path.includes('.pdf') && <span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                                <button className="btn-link btn-link--bold" type="button" onClick={() =>( _doToogleRemarks('show'),loadTicket(selectedData.work_request_id))}>Remarks</button>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Asset Name</label>
                                  <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Priority</label>
                                  <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Vendor Name</label>
                                  <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Issue Description</label>
                                  <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_description} disabled></textarea>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Date & Time*</label>
                                  <input type="text" className="form-control" disabled value={selectedData.created_on && selectedData.created_on.slice(0,19)} />
                                </div>
                              </div>
                              {/* <div className="col-md-12 text-center">
                                <div className="m-page__button  top-space text-center">
                                  <button type='button' className='btn muted-button  deca-btn-orange' onClick={_doVendorReject}>Reject</button>
                                  <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={_doVendorAccept}>Accept</button>
                                </div>
                              </div> */}
                            </React.Fragment>
                          } </React.Fragment>
                        : false}
                      {PendingForConfirmationByVendorAccept === true ?
                        <React.Fragment>
                          <Form className="vendor-accept-form" layout="vertical" form={formAccept}
                            onFinish={(values)=>_doVendorAccepted()}
                          >
                            <div className="col-md-12">
                              <div className='form-group'>
                                <Form.Item
                                  label="Assign Technician*"
                                  name="assign_technician"
                                  rules={[{ required: true, message: 'Please Select Technician' }]}>
                                  <Select className="form-control"
                                    showSearch
                                    placeholder="-- Please Select --"
                                    optionFilterProp="children"
                                    onChange={(value)=>{setAcceptWorkRequest({...acceptWorkRequest, technician:value});
                                    formAccept.setFieldsValue({"assign_technician":value})
                                  }}
                                    filterOption={(input, option) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  > 
                                    {
                                      TechnicianList?.map((item,index)=>{
                                        return(
                                          <Option key={index} value={item.technician_id}>{item.technician_name}</Option>
                                        )
                                      })
                                    }
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <Form.Item
                                label="Mobile Number*"
                                name="mobile_number"
                                rules={[{ required: true, message: 'Please Enter Your Mobile Number' }]}
                                >
                                  <Input className="form-control" minLength = {10} maxLength= { 10 } value={acceptWorkRequest?.technician_number} onChange={(e)=>setAcceptWorkRequest({...acceptWorkRequest,technician_number:e.target.value.replace(/[^0-9]/g, '')})} 
                                  onKeyPress={(e) => {
                                    if (new RegExp(/[0-9]/i).test(e.key)) {
                                    } else e.preventDefault();
                                  }} 
                                  /> 
                                </Form.Item>
                                {/* <label>Mobile Number*</label>
                                <Input type="text" className="form-control" maxLength='10' value={acceptWorkRequest?.technician_number} onChange={(e)=>setAcceptWorkRequest({...acceptWorkRequest,technician_number:e.target.value.replace(/[^0-9]/g, '')})} /> 
                                <p>Please Enter Mobile Number</p> */}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <Form.Item
                                  label="Add Remarks (Max upto 500 characters only)"
                                  name="add_remarks"
                                  rules={[{ required: true, message: 'Please Enter Your Remarks' }]}
                                >
                                  {/* <label>Add Remarks (Max upto 500 characters only)</label> */}
                                  <TextArea rows={4} onChange={(e)=>setAcceptWorkRequest({...acceptWorkRequest, work_request_comments:e.target.value.replace(/[^\w\s]/gi, "")})} maxLength={1000} 
                                  onKeyPress={(e) => {
                                      if (new RegExp(/[a-zA-Z0-9_\s\.\-@]/i).test(e.key)) {
                                      } else e.preventDefault();
                                    }} />
                                </Form.Item>
                              </div>
                            </div>
                            <div className="col-md-12 text-center">
                              <div className="m-page__button 03 top-space text-center">
                                <button type='button' className='btn muted-button  deca-btn-orange' onClick={() => _doPrevAction('AcceptBackBtn')}>Back</button>
                                <Button className='btn btn-secondary deca-btn-yellow' htmlType="submit" style={{backgroundColor:"#ec6607",color:'white'}}>Submit</Button>
                              </div>
                            </div>
                          </Form>
                        </React.Fragment>
                        : false}
                      {PendingForConfirmationByVendorReject === true ?
                        <React.Fragment>
                          <Form className="vendor-reject-form" layout="vertical" form={formReject} 
                          onFinish={(values)=>{_doVendorRejected()
                          }}
                          >
                            <div className="col-md-12">
                              <div className='form-group'>
                                <Form.Item
                                  label="Reason for Rejecting*"
                                  name="reason_for_rejecting"
                                  rules={[{ required: true, message: 'Please Select a Reason' }]}>
                                  <Select className="form-control"
                                    showSearch
                                    placeholder="-- Please Select --"
                                    optionFilterProp="children"
                                    onChange={(value)=>{setRejectWorkRequest({...rejectWorkRequest, reason_for_reject:value})
                                    formReject.setFieldsValue({reason_for_rejecting:value})
                                  }}
                                    filterOption={(input, option) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  > 
                                    <Option value='CHANGE DATE AND TIME'>CHANGE DATE AND TIME</Option>
                                    <Option value='NOT IN SCOPE'>NOT IN SCOPE</Option>
                                    <Option value='NEED MORE CLARIFICATION'>NEED MORE CLARIFICATION</Option>
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <Form.Item
                                  label="Add Remarks (Max upto 500 characters only)"
                                  name="add_remarks"
                                  rules={[{ required: true, message: 'Please Enter Your Mobile Number' }]}
                                >
                                  <TextArea rows={4} onChange={(e)=>setRejectWorkRequest({...rejectWorkRequest, work_request_comments:e.target.value.replace(/[^\w\s]/gi, "")})} maxLength={1000}/>
                                </Form.Item>
                              </div>
                            </div>
                            <div className="col-md-12 text-center">
                              <div className="m-page__button 03 top-space text-center">
                                <button type='button' className='btn muted-button  deca-btn-orange' onClick={() => _doPrevAction('RejectBackBtn')}>Back</button>
                                <Button type='button' className='btn btn-secondary deca-btn-yellow' htmlType="submit" style={{backgroundColor:"#ec6607",color:'white'}}>Submit</Button>
                              </div>
                            </div>
                          </Form>
                        </React.Fragment>
                        : false}
                    </div>
                  </div>
                </div>
              </div>
              : false}
            {WorkRejected === true ?
              <div className="m-modal">
                <div className="m-modal__container">
                  <div className="m-modal__header">
                    <h5 className="m-modal__title"> Rejected </h5>
                    <span className="m-modal__close" onClick={() => _doCloseModal('Rejected')}>
                      <i className="fa fa-close"></i>
                    </span>
                  </div>
                  <div className="m-modal__body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="">
                          <div className="c-pic__img">
                            {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                            {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                          </div>
                        </div>
                      </div>

                      {WorkHistory == true ?
                        <React.Fragment>
                          <div className="col-md-12">
                            <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                          </div>
                          <div className="col-md-12">
                            <ul className="remarks__list">
                              {TicketHistory?.map((item,index)=>{
                                return(
                                  <li className="remarks__item">
                                    <div className="remarks__userdetails">
                                      <h5>{item.from}</h5>
                                      <h5>{item.work_request_start_date}</h5>
                                    </div>
                                    <div className="remarks__reason">
                                      <h5>Comments</h5>
                                      <p>{item.work_request_comments}</p>
                                    </div>
                                    <div className="remarks__userdetails">
                                      <p>Reschedule Date</p>
                                      <p>{item.work_request_reschedule_date}</p>
                                    </div>
                                  </li>
                                )
                            })}
                              
                            </ul>
                          </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          <div className="col-md-12 status_remarks">
                          {selectedData?.pdf_path.includes('.pdf') && <span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                            <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('show')}>Remarks</button>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Asset Name</label>
                              <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Priority</label>
                              <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Vendor Name</label>
                              <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Issue Description</label>
                              <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_reject_remarks} disabled></textarea>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Date & Time*</label>
                              <input type="text" className="form-control" disabled value={selectedData.work_request_start_date} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Reason for Rejected*</label>
                              <input type="text" className="form-control" disabled value={selectedData.work_request_reject_remarks} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Remakrs</label>
                              <input type="text" className="form-control" disabled value={selectedData.work_request_comments} />
                            </div>
                          </div>
                        </React.Fragment>
                      }
                    </div>
                  </div>
                </div>
              </div>
              : false}
            {AssignedToTech === true ?
              <div className="m-modal">
                <div className="m-modal__container">
                  <div className="m-modal__header">
                    <h5 className="m-modal__title">Assigned to Technician</h5>
                    <span className="m-modal__close" onClick={() => _doCloseModal('AssignedToTech')}>
                      <i className="fa fa-close"></i>
                    </span>
                  </div>
                  <div className="m-modal__body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="">
                          <div className="c-pic__img">
                            {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                            {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                          </div>
                        </div>
                      </div>
                      {WorkHistory == true ?
                        <React.Fragment>
                          <div className="col-md-12">
                            <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                          </div>
                          <div className="col-md-12">
                            <ul className="remarks__list">
                              {TicketHistory?.map((item,index)=>{
                                      return(
                                        <li className="remarks__item">
                                          <div className="remarks__userdetails">
                                            <h5>{item.from}</h5>
                                            <h5>{item.work_request_start_date}</h5>
                                          </div>
                                          <div className="remarks__reason">
                                            <h5>Comments</h5>
                                            <p>{item.work_request_comments}</p>
                                          </div>
                                          <div className="remarks__userdetails">
                                            <p>Reschedule Date</p>
                                            <p>{item.work_request_reschedule_date}</p>
                                          </div>
                                        </li>
                                      )
                              })}
                            </ul>
                          </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          <div className="col-md-12 status_remarks">
                          {selectedData?.pdf_path.includes('.pdf') &&<span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                            <button className="btn-link btn-link--bold" type="button" onClick={() =>( _doToogleRemarks('show'), loadTicket(selectedData.work_request_id))}>Remarks</button>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Asset Name</label>
                              <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Priority</label>
                              <input type="text" className="form-control" disabled value={selectedData.work_request_priority}/>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Vendor Name</label>
                              <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Issue Description</label>
                              <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_description} disabled></textarea>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Scheduled Date & time*</label>
                              <input type="text" className="form-control" disabled value={selectedData.submitted_date_time} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Name Of Techincaion</label>
                              <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Mobile</label>
                              <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Remarks</label>
                              <textarea type="text" rows="3" className="form-control" value={selectedData.workrequest_remarks} disabled></textarea>
                            </div>
                          </div>
                        </React.Fragment>
                      }
                    </div>
                  </div>
                </div>
              </div>
              : false}
            {TechCompleted === true || TechInComplete === true || UnderQuotation === true || WorkClosed === true ?
              <div className="m-modal">
                <div className="m-modal__container">
                  <div className="m-modal__header">
                    {TechCompleted === true ?
                      <React.Fragment>
                        <h5 className="m-modal__title">Technician Completed</h5>
                        <span className="m-modal__close" onClick={() => _doCloseModal('TechCompleted')}>
                          <i className="fa fa-close"></i>
                        </span>
                      </React.Fragment>
                      : null
                    }
                    {TechInComplete === true ?
                      <React.Fragment>
                        <h5 className="m-modal__title">Technician Incomplete</h5>
                        <span className="m-modal__close" onClick={() => _doCloseModal('TechInComplete')}>
                          <i className="fa fa-close"></i>
                        </span>
                      </React.Fragment> : null}
                    {UnderQuotation === true ?
                      <React.Fragment>
                        <h5 className="m-modal__title">Under Quotation</h5>
                        <span className="m-modal__close" onClick={() => _doCloseModal('UnderQuotation')}>
                          <i className="fa fa-close"></i>
                        </span>
                      </React.Fragment> : null}
                      {WorkClosed === true ?
                      <React.Fragment>
                        <h5 className="m-modal__title">Work Closed</h5>
                        <span className="m-modal__close" onClick={() => _doCloseModal('WorkClosed')}>
                          <i className="fa fa-close"></i>
                        </span>
                      </React.Fragment> : null}
                  </div>
                  <div className="m-modal__body">
                    <div className="row">
                    {TechInComplete === true ?
                            <div className="col-md-12 text-center">
                              <div className="m-page__button  top-space text-center">
                                <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={() => (_doNavToQuotation('Add'))}>Create Quotation</button>
                              </div>
                            </div>
                    : false}
                      <div className="col-md-12">
                        <div className="">
                          <div className="c-pic__img">
                            {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                            {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                          </div>
                        </div>
                      </div>
                      {WorkHistory == true ?
                        <React.Fragment>
                          <div className="col-md-12">
                            <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                          </div>
                          <div className="col-md-12">
                            <ul className="remarks__list">
                            {TicketHistory?.map((item,index)=>{
                                  return(
                                    <li className="remarks__item">
                                      <div className="remarks__userdetails">
                                        <h5>{item.from}</h5>
                                        <h5>{item.work_request_start_date}</h5>
                                      </div>
                                      <div className="remarks__reason">
                                        <h5>Comments</h5>
                                        <p>{item.work_request_comments}</p>
                                      </div>
                                      <div className="remarks__userdetails">
                                        <p>Reschedule Date</p>
                                        <p>{item.work_request_reschedule_date}</p>
                                      </div>
                                    </li>
                                  )
                                })}
                            </ul>
                          </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          <div className="col-md-12 status_remarks">
                          {selectedData?.pdf_path.includes('.pdf') &&<span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                            <button className="btn-link btn-link--bold" type="button" onClick={() => (_doToogleRemarks('show'),loadTicket(selectedData.work_request_id))}>Remarks</button>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Asset Name</label>
                              <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Priority</label>
                              <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Issue Description</label>
                              <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_description} disabled></textarea>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Scheduled Date & time*</label>
                              <input type="text" className="form-control" disabled value={selectedData && selectedData.created_on.slice(0,19)} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Submitted Date & time*</label>
                              <input type="text" className="form-control" disabled value={selectedData && selectedData.submitted_date_time.slice(0,19)} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Name Of Techincaion</label>
                              <input type="text" className="form-control" disabled value={selectedData.technician_name}/>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Mobile</label>
                              <input type="text" className="form-control" disabled value={selectedData.technician_number} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Signature By Technician</label>
                              <img className ='technician-img' src={apiInterface+`/downloadimages?Image_id=${selectedData.technician_signature_image}`}  alt="Signature By Technician" />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Technician Selfie Image</label>
                              <img className ='technician-img' src={apiInterface+`/downloadimages?Image_id=${selectedData.technician_selfie_image}`} alt="Technician selfie image" />
                            </div>
                          </div>
                          
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Remarks by Technician</label>
                              <input type="text" className="form-control" disabled value={selectedData.workrequest_remarks} />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Attached Image</label>
                              <img className ='technician-img' src={apiInterface+`/downloadimages?Image_id=${selectedData.completed_image}`} alt="Issue Image" />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Quotation</label>
                              {/* <input type="text" className="form-control" disabled value={selectedData.quotation_required} /> */}
                              <input type="checkbox"  disabled checked={selectedData.quotation_required==0 ? false : true} style={{width:20,height:20,display:'block'}}/>
                            </div>
                          </div>
                          {/* {TechInComplete === true ?
                            <div className="col-md-12 text-center">
                              <div className="m-page__button  top-space text-center">
                                <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={() => (_doNavToQuotation('Add'))}>Create Quotation</button>
                              </div>
                            </div>
                            : false} */}
                          {UnderQuotation === true || WorkClosed === true ?
                            <div className="col-md-12 text-center">
                              <div className="m-page__button  top-space text-center">
                                <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={() => _doNavToQuotation('view')}>View Quotation</button>
                              </div>
                            </div>
                            : false}
                        </React.Fragment>
                      }
                    </div>
                  </div>
                </div>
              </div>
              : false}
              {isPendingFromVendor === true ?
              <div className="m-modal">
                <div className="m-modal__container">
                  <div className="m-modal__header">
                    <h5 className="m-modal__title"> Pending From Vendor</h5>
                    <span className="m-modal__close" onClick={() => _doCloseModal('pendingFromVendor')}>
                      <i className="fa fa-close"></i>
                    </span>
                  </div>
                  <div className="m-modal__body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="">
                          <div className="c-pic__img">
                            {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                            {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                          </div>
                        </div>
                      </div>
                      {PendingForConfirmationByVendorAccept === false && PendingForConfirmationByVendorReject === false ?
                        <React.Fragment>
                          {WorkHistory == true ?
                            <React.Fragment>
                              <div className="col-md-12">
                                <button className="btn-link btn-link--bold" type="button" onClick={() => _doToogleRemarks('hide')}>Go Back</button>
                              </div>
                              <div className="col-md-12">
                                <ul className="remarks__list">
                                  {TicketHistory?.map((item,index)=>{
                                    return(
                                      <li className="remarks__item">
                                        <div className="remarks__userdetails">
                                          <h5>{item.from}</h5>
                                          <h5>{item.work_request_start_date}</h5>
                                        </div>
                                        <div className="remarks__reason">
                                          <h5>Comments</h5>
                                          <p>{item.work_request_comments}</p>
                                        </div>
                                        <div className="remarks__userdetails">
                                          <p>Reschedule Date</p>
                                          <p>{item.work_request_reschedule_date}</p>
                                        </div>
                                      </li>
                                    )
                                })}
                                  
                                </ul>
                              </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                              <div className="col-md-12 status_remarks">
                              {selectedData?.pdf_path.includes('.pdf') &&<span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                                <button className="btn-link btn-link--bold" type="button" onClick={() =>( _doToogleRemarks('show'),loadTicket(selectedData.work_request_id))}>Remarks</button>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Asset Name</label>
                                  <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Priority</label>
                                  <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Vendor Name</label>
                                  <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Issue Description</label>
                                  <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_description} disabled></textarea>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Date & Time*</label>
                                  <input type="text" className="form-control" disabled value={selectedData.created_on && selectedData.created_on.slice(0,19)} />
                                </div>
                              </div>
                              {/* <div className="col-md-12 text-center">
                                <div className="m-page__button  top-space text-center">
                                  <button type='button' className='btn muted-button  deca-btn-orange' onClick={_doVendorReject}>Reject</button>
                                  <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={_doVendorAccept}>Accept</button>
                                </div>
                              </div> */}
                            </React.Fragment>
                          } </React.Fragment>
                        : false}
                    </div>
                  </div>
                </div>
              </div>
              : false}
          </div>
          {(RejectedByVendor|| isWorkRejectedByStore ) ?
                <div className="m-modal">
                  <div className="m-modal__container">
                    <div className="m-modal__header">
                      <h5 className="m-modal__title"> 
                      {
                        RejectedByVendor ? "Rejected By Vendor"
                        : isWorkRejectedByStore ? "Work Rejected By store"
                        :""
                      } 
                      </h5>
                      <span className="m-modal__close" 
                        onClick={() => 
                          RejectedByVendor ? _doCloseModal('RejectedByVendor')
                          : isWorkRejectedByStore ? _doCloseModal('WorkRejectedByStore')
                          :""}
                      >
                        <i className="fa fa-close"></i>
                      </span>
                    </div>
                    <div className="m-modal__body">
                      <div className="row">
                      <div className="col-md-12 text-center">
                      <div className="m-page__button  top-space text-center">
                        {/* <button type='button' className='btn muted-button  deca-btn-orange' onClick={_doVendorReject}>Reject</button> */}
                        {isWorkRejectedByStore &&<button type='button' className='btn btn-secondary deca-btn-yellow' onClick={_doVendorAccept}>Accept</button>}
                      </div>
                    </div>
                        <div className="col-md-12">
                          <div className="">
                            <div className="c-pic__img">
                              {/* <img src={apiInterface+`/displaystoreimages?info_row_id=${selectedData.asset_id}&&type=2`} className="" alt="asset-img" /> */}
                              {selectedData.work_request_image !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image}`} className="" alt="work_request_image" />}
                            {selectedData.work_request_image1 !='' && <img src={apiInterface+`/downloadimages?Image_id=${selectedData.work_request_image1}`} className="" alt="work_request_image1" />}
                            </div>
                          </div>
                        </div>
    
                        {WorkHistory == true ?
                          <React.Fragment>
                            <div className="col-md-12">
                              <button className="btn-link btn-link--bold" type="button" onClick={() =>_doToogleRemarks('hide')}>Go Back</button>
                            </div>
                            <div className="col-md-12">
                              <ul className="remarks__list">
                              {TicketHistory?.map((item,index)=>{
                                    return(
                                      <li className="remarks__item">
                                        <div className="remarks__userdetails">
                                          <h5>{item.from}</h5>
                                          <h5>{item.work_request_start_date}</h5>
                                        </div>
                                        <div className="remarks__reason">
                                          <h5>Comments</h5>
                                          <p>{item.work_request_comments}</p>
                                        </div>
                                        <div className="remarks__userdetails">
                                          <p>Reschedule Date</p>
                                          <p>{item.work_request_reschedule_date}</p>
                                        </div>
                                      </li>
                                    )
                                })}
                              </ul>
                            </div>
                          </React.Fragment>
                          :PendingForConfirmationByVendorAccept === true ?
                        <React.Fragment>
                          <Form className="vendor-accept-form" layout="vertical" form = {formAccept1}
                          onFinish={(values)=>{
                            _doVendorAccepted();
                          }}
                          >
                            <div className="col-md-12">
                              <div className='form-group'>
                                <Form.Item
                                  label="Assign Technician*"
                                  name="assign_technician"
                                  rules={[{ required: true, message: 'Please Select Technician' }]}>
                                  <Select className="form-control"
                                    showSearch
                                    placeholder="-- Please Select --"
                                    optionFilterProp="children"
                                    onChange={(value)=>{setAcceptWorkRequest({...acceptWorkRequest, technician:value})
                                    formAccept1.setFieldsValue({"assign_technician":value})
                                  }}
                                    filterOption={(input, option) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  > 
                                    {
                                      TechnicianList?.map((item,index)=>{
                                        return(
                                          <Option key={index} value={item.technician_id}>{item.technician_name}</Option>
                                        )
                                      })
                                    }
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                              <Form.Item
                                label="Mobile Number*"
                                name="mobile_number"
                                rules={[{ required: true, message: 'Please Enter Your Mobile Number' }]}
                                >
                                {/* <label>Mobile Number*</label> */}
                                <Input type="text" className="form-control" minLength = {10} maxLength={10} value={acceptWorkRequest?.technician_number} onChange={(e)=>setAcceptWorkRequest({...acceptWorkRequest,technician_number:e.target.value.replace(/[^0-9]/g, '')})}
                                onKeyPress={(e) => {
                                  if (new RegExp(/[0-9]/i).test(e.key)) {
                                  } else e.preventDefault();
                                }} 
                                />
                                </Form.Item>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <Form.Item
                                  label="Add Remarks (Max upto 500 characters only)"
                                  name="add_remarks"
                                  rules={[{ required: true, message: 'Please Add Your Remarks' }]}
                                >
                                  {/* <label>Add Remarks (Max upto 500 characters only)</label> */}
                                  <TextArea rows={4} onChange={(e)=>setAcceptWorkRequest({...acceptWorkRequest, work_request_comments:e.target.value.replace(/[^\w\s]/gi, "")})} maxLength={1000}
                                  onKeyPress={(e) => {
                                      if (new RegExp(/[a-zA-Z0-9_\s\.\-@]/i).test(e.key)) {
                                      } else e.preventDefault();
                                    }}/>
                                </Form.Item>
                              </div>
                            </div>
                            <div className="col-md-12 text-center">
                              <div className="m-page__button 03 top-space text-center">
                                <button type='button' className='btn muted-button  deca-btn-orange' onClick={() => _doPrevAction('AcceptBackBtn')}>Back</button>
                                <Button type='button' className='btn btn-secondary deca-btn-yellow' htmlType="submit" style={{backgroundColor:"#ec6607",color:'white'}}>Submit</Button>
                              </div>
                            </div>
                          </Form>
                        </React.Fragment>
                        : <React.Fragment>
                        <div className="col-md-12 status_remarks">
                        {selectedData?.pdf_path.includes('.pdf') &&<span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                          <button className="btn-link btn-link--bold" type="button" onClick={() =>(_doToogleRemarks('show'),loadTicket(selectedData.work_request_id))}>Remarks</button>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Asset Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.asset_name} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Priority</label>
                            <input type="text" className="form-control" disabled value={selectedData.work_request_priority} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Vendor Name</label>
                            <input type="text" className="form-control" disabled value={selectedData.vendor_company_name} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Issue Description</label>
                            <textarea type="text" rows="3" className="form-control" value={selectedData.work_request_description} disabled></textarea>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Date & Time</label>
                            <input type="text" className="form-control" disabled value={selectedData.work_request_start_date} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Reason for Rejected</label>
                            <input type="text" className="form-control" disabled value={selectedData.work_request_reject_remarks} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Remakrs</label>
                            <input type="text" className="form-control" disabled value={selectedData.workrequest_remarks} />
                          </div>
                        </div>
                      </React.Fragment>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                : false}
          {
              isReportGenerator === true ?
                <Modal title="Download Report" width={1000} closeIcon open={isModalVisible}
                    footer={[
                        <Button key="back" onClick={handleCloseReportGenerator}>
                            Cancel
                        </Button>
                    ]}>
                      <div className="row">
                      <div className="col-md-3">
                        <div className='form-group'>
                          <label htmlFor='exampleInput'>Select Store</label>
                          <Select className="form-control"
                            showSearch
                            onChange={(value)=>setReportData({...reportData,storeId:value})}
                            placeholder="-- Please Select --"
                            optionFilterProp="children"
                            // value={storeId}
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          > {
                            StoreDetails?.map(((item,index) =>
                                <Option key={index} value={item.store_id}>{item.store_name}</Option>
                              ))
                            }
                          </Select>
                          {reportData.storeId == null && isSubmit == true && <span className='text-danger'>Please Select Store</span>}
                        </div>
                      </div>
                      <div className="col-md-4">
                          <div className="form-group">
                              <label htmlFor='exampleInput'>Start Date*</label>
                              <DatePicker className="form-control" format={'DD-MM-YYYY'} disabledDate={disabledDate} onChange={(date, dateString) => setReportData({...reportData,startDate:dateString})}/>
                              {(reportData.startDate == null || reportData.startDate == '') && isSubmit == true && <span className='text-danger'>Please Select Start Date</span>}
                          </div>
                      </div>
                      <div className="col-md-4">
                          <div className="form-group">
                              <label htmlFor='exampleInput'>End Date*</label>
                              <DatePicker className="form-control" format={'DD-MM-YYYY'} disabledDate={disabledDate} onChange={(date, dateString) => setReportData({...reportData,endDate:dateString})}/>
                              {(reportData.endDate == null || reportData.endDate == '') && isSubmit == true && <span className='text-danger'>Please Select End Date</span>}
                          </div>
                      </div>

                      <div className="col-md-1 btn-no-lbl">
                        <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={()=>handleSearchReport()}>
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                        <div className='form-group'>
                          <label htmlFor='exampleInput'>Select Subcategory</label>
                          <Select className="form-control"
                            showSearch
                            onChange={(value)=>setReportSubId(value)}
                            placeholder="-- Please Select --"
                            optionFilterProp="children"
                            allowClear={true}
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          > {
                            SubCategoryList?.map(((item,index) =>
                                <Option key={index} value={item.sub_category_id}>{item.sub_category_name}</Option>
                              ))
                            }
                          </Select>
                        </div>
                    </div>
                    <div className="col-md-1 btn-no-lbl">
                      <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleReportTableData}>
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='table'>
                                <table className='table table-striped table-bordered'>
                                    <thead className='bg-primary'>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Subcategory Name</th>
                                            <th>Asset Name</th>
                                            <th>Start Date</th>
                                            <th>Vendor Name</th>
                                            <th>Technician Name</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-center'>
                                        
                                        {
                                            reportTableData?.map((ele,index)=>{
                                                return(
                                                    <tr key = {index}>
                                                        <td>{index+1}</td>
                                                        <td>{ele.sub_category_name}</td>
                                                        <td>{ele.asset_name}</td>
                                                        <td>{ele.work_request_start_date}</td>
                                                        <td>{ele.vendor_company_name}</td>
                                                        <td>{ele.technician_name}</td>
                                                        {/* <td onClick={()=>handleDownloadReport(ele)} style={{cursor:'pointer'}}>{ele.pdf_path.includes('.pdf')&&<i className="fa fa-download"/>}</td> */}
                                                        <td onClick={()=>handleDownloadReport(ele)} style={ele.pdf_path.includes('.pdf')? {cursor:'pointer'}:{cursor:'default'}}>{ele.pdf_path.includes('.pdf')&&<i className="fa fa-download"/>}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </Modal>
                : false
          }
        </div >
        :isViewQutation === true ?
        <ViewQuotation
        selectedData = {selectedData}
        CloseViewQuotation = {CloseQuotation}
        />: isViewAddQuotation ===true ? <AddQuotation 
        selectedData = {
            selectedData
        }
        CloseAddQuotation = {
          CloseAddViewQuotation
        }
        /> :""}
      </>
    )

}
export default WorkOrderVendor;

